import auth from "../../apis/auth";
// const auth = RepositoryFactory.auth;
// import jwt from "jsonwebtoken";

export default {
  signupWithPassword({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.signupWithPassword(payload);

        // Set accessToken
        // localStorage.setItem("token", data.data.token);
        sessionStorage.setItem("token", data.data.token);

        // Update user details
        commit("UPDATE_USER_INFO", data.data.user);
        commit("USER_ROLE", data.data.user.role);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  generateOTP({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.generateOTP(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  loginWithPassword({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.loginWithPassword(payload);
        // Set accessToken
        sessionStorage.setItem("token", data.data.token);
        // localStorage.setItem("token", data.data.token);

        // Update user details
        commit("UPDATE_USER_INFO", data.data.user);
        commit("USER_ROLE", data.data.user.role);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  VerifyOTP({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.VerifyOTP(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  forgotPassword({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.forgotPassword(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  passwordChangeRequest({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.PasswordChangeRequest(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  passwordChange({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.PasswordChange(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  logout({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.logout(payload);

        await commit("logout", null, { root: true });

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updateInfo({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.UpdateUserDetails(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updateUserProfile({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.updateUserProfile(payload);

        commit("UPDATE_USER_IMAGE", data.data.userImage);
        // console.log(data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updateUserCoverImage({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.updateUserCoverImage(payload);
        // console.log(data);
        commit("UPDATE_USER_COVER_IMAGE", data.data.coverImage);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  signUpWithGoogle({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.signUpWithGoogle(payload);
        // Set accessToken
        sessionStorage.setItem("token", data.data.token);
        // localStorage.setItem("token", data.data.token);

        // Update user details
        commit("UPDATE_USER_INFO", data.data.user);
        commit("USER_ROLE", data.data.user.role);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  signUpWithLinkedin({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.signUpWithLinkedin(payload);
        // Set accessToken
        sessionStorage.setItem("token", data.data.token);
        // localStorage.setItem("token", data.data.token);

        // Update user details
        commit("UPDATE_USER_INFO", data.data.user);
        commit("USER_ROLE", data.data.user.role);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  signUpWithWhatsapp({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.signUpWithWhatsapp(payload);
        // Set accessToken
        sessionStorage.setItem("token", data.data.token);
        // localStorage.setItem("token", data.data.token);

        // Update user details
        commit("UPDATE_USER_INFO", data.data.user);
        commit("USER_ROLE", data.data.user.role);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  signInWithGoogle({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.signInWithGoogle(payload);
        // Set accessToken

        sessionStorage.setItem("token", data.data.token);
        // localStorage.setItem("token", data.data.token);

        // Update user details
        commit("UPDATE_USER_INFO", data.data.user);
        commit("USER_ROLE", data.data.user.role);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getUserByUserId({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.getUserByUserId(payload);

        // Update user details
        commit("GET_USER_BY_USER_ID", data.data.user);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getUser({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.getUser(payload);

        // Update user details
        commit("GET_USER", data.data.user);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
